import React from 'react';
import RawGenericDatePicker from '../generic-date-picker/RawGenericDatePicker';
import styled from 'styled-components';
function RawPeriodDatePicker({onChange, label, disabled, monthsShown, endDate, startDate}) {
    return (
        <Wrapper>
            <RawGenericDatePicker
                monthsShown={monthsShown}
                onChange={onChange}
                dateFormat="dd MMMM yyyy"
                selectsRange
                startDate={startDate}
                endDate={endDate}
                disabled={disabled}
                label={label}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    .react-datepicker-popper {
        min-width: 490px;
    }
`;
export {RawPeriodDatePicker};
